var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotTick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.95496 16.9265C9.66681 16.9265 9.39308 16.8112 9.19138 16.6095L5.11414 12.5323C4.69633 12.1145 4.69633 11.4229 5.11414 11.0051C5.53195 10.5873 6.22349 10.5873 6.6413 11.0051L9.95496 14.3188L17.3603 6.91345C17.7781 6.49565 18.4696 6.49565 18.8874 6.91345C19.3052 7.33126 19.3052 8.02281 18.8874 8.44062L10.7185 16.6095C10.5168 16.8112 10.2431 16.9265 9.95496 16.9265Z",
    fill: "#1BB75E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotTick);
export default __webpack_public_path__ + "static/media/not-tick.598445907d7012bce99198c79ba671ea.svg";
export { ForwardRef as ReactComponent };